var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 24.907 24.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2435533773280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M2.092,18.739V6.188A4.135,4.135,0,0,1,6.178,2.1H18.729a4.135,4.135,0,0,1,4.086,4.086V18.739a4.135,4.135,0,0,1-4.086,4.086H6.178a4.135,4.135,0,0,1-4.086-4.086ZM0,5.945V18.982a6.242,6.242,0,0,0,5.935,5.935H18.972a6.1,6.1,0,0,0,2.383-.584,6.372,6.372,0,0,0,2.967-2.967,6.1,6.1,0,0,0,.584-2.383V5.945a6.1,6.1,0,0,0-.584-2.383,6.7,6.7,0,0,0-1.228-1.74,7.206,7.206,0,0,0-.794-.666A6.124,6.124,0,0,0,18.972.01H5.935A6.19,6.19,0,0,0,1.812,1.822a7.206,7.206,0,0,0-.666.794A6.124,6.124,0,0,0,0,5.945Z",
    transform: "translate(0 -0.01)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M492.48,901.313a1.061,1.061,0,0,0,1.167,1.168h10.118a1.078,1.078,0,1,0-.049-2.14H493.7c-.654,0-1.216.368-1.216.973Z",
    transform: "translate(-486.253 -888.957)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M492.48,1312.993a1.017,1.017,0,0,0,.973,1.119h10.508a1.048,1.048,0,0,0-.049-2.092H493.5a1.035,1.035,0,0,0-1.022.973Z",
    transform: "translate(-486.254 -1295.432)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M492.49,493.463a1.028,1.028,0,0,0,1.022,1.119h10.41a1.048,1.048,0,0,0,.049-2.092H493.463a1.02,1.02,0,0,0-.973.973Z",
    transform: "translate(-486.263 -486.264)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.9257a3478c0757bc37a9b306e61a5365.svg";
export { ForwardRef as ReactComponent };